(() => {
  const getBar = () => document.querySelector('[data-collection-aov-motivator]');
  const isCollectionThree = () =>
    Boolean(
      document.querySelector(
        'collection-ajax-experience[data-cardology-collection-template="collection-page-3"]'
      )
    );

  const openPersonalizeCart = () => {
    const cartTrigger = document.getElementById('cart-icon-bubble');
    if (!cartTrigger) return;
    cartTrigger.click();
  };

  const clearAutoHide = (bar) => {
    if (!bar) return;
    window.clearTimeout(bar.caeAutoHideTimer);
    bar.caeAutoHideTimer = null;
  };

  const hideBar = (bar) => {
    if (!bar) return;
    clearAutoHide(bar);
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');

    window.clearTimeout(bar.hideAttributeTimer);
    bar.hideAttributeTimer = window.setTimeout(() => {
      if (!bar.classList.contains('is-visible')) bar.hidden = true;
    }, 240);
  };

  const scheduleAutoHide = (bar) => {
    clearAutoHide(bar);
    if (!bar || bar.dataset.autoHide !== 'true' || !bar.classList.contains('is-visible')) return;

    const durationSeconds = Number(bar.dataset.duration || 7);
    const durationMs = Math.max(1, Number.isFinite(durationSeconds) ? durationSeconds : 7) * 1000;

    bar.caeAutoHideTimer = window.setTimeout(() => hideBar(bar), durationMs);
  };

  const handleViewBasket = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const bar = event.currentTarget.closest('[data-collection-aov-motivator]') || getBar();
    clearAutoHide(bar);
    hideBar(bar);

    // Use the same cart trigger that already opens the Personalize app drawer.
    // Do not query/open the Honey theme <cart-drawer> directly.
    openPersonalizeCart();
  };

  const bindCollectionThreeProductDrawer = () => {
    if (!isCollectionThree()) return;
    if (document.documentElement.dataset.caeCollectionThreeDrawerBound === 'true') return;

    document.documentElement.dataset.caeCollectionThreeDrawerBound = 'true';

    const productAddObserver = new MutationObserver((mutations) => {
      const successfulAdd = mutations.find((mutation) => {
        if (mutation.type !== 'attributes' || mutation.attributeName !== 'data-cae-added') {
          return false;
        }

        const target = mutation.target;
        if (!(target instanceof Element)) return false;
        if (!target.closest('.cae-products')) return false;

        return (
          target.matches('[data-add-to-cart]') &&
          target.getAttribute('data-cae-added') === 'true'
        );
      });

      if (!successfulAdd) return;

      // collection-aov-motivator.js sets data-cae-added only after the AJAX
      // /cart/add request and cart refresh have completed successfully.
      window.requestAnimationFrame(() => openPersonalizeCart());
    });

    productAddObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['data-cae-added'],
    });
  };

  const bindBar = () => {
    const bar = getBar();
    if (!bar || bar.dataset.caeAutoHideBound === 'true') return;

    bar.dataset.caeAutoHideBound = 'true';

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.attributeName === 'class')) {
        if (bar.classList.contains('is-visible')) scheduleAutoHide(bar);
        else clearAutoHide(bar);
      }
    });

    observer.observe(bar, { attributes: true, attributeFilter: ['class'] });

    bar.querySelector('[data-aov-close]')?.addEventListener('click', () => clearAutoHide(bar));

    const originalViewBasket = bar.querySelector('[data-aov-view-basket]');
    if (originalViewBasket) {
      const cleanViewBasket = originalViewBasket.cloneNode(true);
      originalViewBasket.replaceWith(cleanViewBasket);
      cleanViewBasket.addEventListener('click', handleViewBasket);
    }

    if (bar.classList.contains('is-visible')) scheduleAutoHide(bar);
  };

  const setup = () => {
    bindBar();
    bindCollectionThreeProductDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('collection:updated', setup);
})();